import _ from 'lodash'
import { Map, List, fromJS } from 'immutable'
import { getParams, getState } from '../../lib/processPortalRules'
import { recursivePrepareSFMapping } from './recursivePrepareSFMapping'
import { getAxios } from '../../lib/projectAxios'
import * as actionTypes from './actionTypes'
import { setTargetParamsValue } from './setTargetParamValue'
import { SESSION_TOKEN_NAME, SESSION_SALT_NAME, OTP_SESSION_IS_ACTIVE } from '../../constants/session'
import { ftSetLocalStorage } from '../../lib/common'

const axios = getAxios()

export const processOtpLogin = (hashJobs) => async (dispatch, getAppState) => {
  let state = getAppState()
  let sett = state.getIn(['project', 'Settings', 'otpSettings'], Map()).toJS()
  let sfMapping = {}
  if (sett && sett.fields) {
    if (!_.size(sett.fields)) {
      return {
        status: false,
      }
    }
    let fields = []
    _.each(sett.fields, (field) => {
      let [group, value] = String(field).split('#-#')
      fields.push({
        group,
        value,
      })
    })
    sfMapping['login'] = {
      type: 'custom',
      loadingMessage: ' ',
      gridFields: [],
      fields,
    }
  } else {
    if (!sett.init || !sett.login) {
      return {
        status: false,
      }
    }
    let mapping = state.getIn(['project', 'Settings', 'sfMapping'])
    if (!mapping) {
      return {
        status: false,
      }
    }
    mapping = mapping.toJS()

    sfMapping[sett.login] = mapping[sett.login]
    sfMapping[sett.init] = mapping[sett.init]
  }

  const params = getParams(state)
  const widgetsData = getState(state)
  let list = recursivePrepareSFMapping(sfMapping, 'custom', [], widgetsData, params, false, [], sfMapping)

  dispatch({
    type: actionTypes.SHOW_LOADING_WINDOW,
    payload: {
      messages: [],
    },
  })

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/otp/request', {
        list,
      })
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { data } = await recursiveProcessGet(0)

  dispatch({
    type: actionTypes.CLOSE_LOADING_WINDOW,
  })

  dispatch({
    type: actionTypes.PROCESS_SF_CHILD_MAPPING,
    payload: {
      path: [],
      list: list,
      repeatIndex: null,
      data: data,
      isShowLoading: false,
      loadingMessages: [],
      sfMessages: {},
      inQuery: true,
      ignoreValidations: false,
    },
  })

  if (_.size(hashJobs)) {
    let retState = getAppState()
    let isNeedProcess = false
    if (data.status) {
      let otpCache = Map()
      if (hashJobs['invalidVerify']) {
        otpCache = otpCache.set('invalidVerify', hashJobs['invalidVerify'])
      }
      if (hashJobs['validVerify']) {
        otpCache = otpCache.set('validVerify', hashJobs['validVerify'])
      }

      isNeedProcess = true

      retState = retState.setIn(['__otp_cache__'], otpCache)

      if (hashJobs['validInit']) {
        retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).concat(hashJobs['validInit']))
      }

      if (hashJobs['validLogin']) {
        retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).concat(hashJobs['validLogin']))
      }
    } else {
      if (data.code && !isNaN(data.code) && data.code <= 2) {
        if (hashJobs['invalidInit']) {
          retState = retState.setIn(
            ['__cache__'],
            retState.getIn(['__cache__'], List()).concat(hashJobs['invalidInit'])
          )
          isNeedProcess = true
        }
      } else {
        if (hashJobs['invalidLogin']) {
          retState = retState.setIn(
            ['__cache__'],
            retState.getIn(['__cache__'], List()).concat(hashJobs['invalidLogin'])
          )
          isNeedProcess = true
        }
      }
    }
    if (isNeedProcess) {
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: retState,
        },
      })
    }
  }
  if (data.status) {
    dispatch(
      setTargetParamsValue({
        params: {
          otpSalt: data.salt,
        },
      })
    )
  }
}

export const processOtpVerify = (code, callback, hashJobs) => async (dispatch, getAppState) => {
  let state = getAppState()
  let sett = state.getIn(['project', 'Settings', 'otpSettings'], Map()).toJS()

  if (!state.getIn(['params', 'otpSalt'])) {
    if (sett.isOnFail) {
      let retState = getAppState()
      let invalidVerify = retState.getIn(['__otp_cache__', 'invalidVerify'], List())
      if (invalidVerify.size) {
        retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).concat(invalidVerify))
        dispatch({
          type: actionTypes.SET_STORE,
          payload: {
            store: retState,
          },
        })
      }
    }
    return callback({
      status: false,
    })
  }

  const processErrors = () => {
    let retState = getAppState()
    let processList = List()
    let invalidVerify = retState.getIn(['__otp_cache__', 'invalidVerify'], List())
    if (invalidVerify.size) {
      processList = processList.concat(invalidVerify)
    }
    if (hashJobs && hashJobs.invalidVerify && _.size(hashJobs.invalidVerify)) {
      processList = processList.concat(fromJS(hashJobs.invalidVerify))
    }
    if (processList.size) {
      retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).concat(processList))
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: retState,
        },
      })
    }
  }
  let sfMapping = {}

  if (sett && sett.fields) {
    if (!_.size(sett.fields)) {
      return {
        status: false,
      }
    }
    let fields = []
    _.each(sett.fields, (field) => {
      let [group, value] = String(field).split('#-#')
      fields.push({
        group,
        value,
      })
    })
    sfMapping['verify'] = {
      type: 'custom',
      loadingMessage: ' ',
      gridFields: [],
      fields,
    }
  } else {
    if (!sett.verify) {
      return callback({
        status: false,
      })
    }

    let mapping = state.getIn(['project', 'Settings', 'sfMapping'])
    if (!mapping) {
      return callback({
        status: false,
      })
    }
    mapping = mapping.toJS()
    sfMapping[sett.verify] = mapping[sett.verify]
  }

  const params = getParams(state)
  const widgetsData = getState(state)
  let list = recursivePrepareSFMapping(sfMapping, 'custom', [], widgetsData, params, false, [], sfMapping)

  dispatch({
    type: actionTypes.SHOW_LOADING_WINDOW,
    payload: {
      messages: [],
    },
  })

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/otp/verify', {
        list,
        code,
        salt: state.getIn(['params', 'otpSalt']),
      })
      return result
    } catch (err) {
      console.log('err >>> ', err)
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { data } = await recursiveProcessGet(0)

  dispatch({
    type: actionTypes.CLOSE_LOADING_WINDOW,
  })

  dispatch({
    type: actionTypes.PROCESS_SF_CHILD_MAPPING,
    payload: {
      path: [],
      list: list,
      repeatIndex: null,
      data: data,
      isShowLoading: false,
      loadingMessages: [],
      sfMessages: {},
      inQuery: true,
      ignoreValidations: false,
    },
  })

  if (data.status) {
    const params = {
      otpSalt: '',
      isOtpLogged: true,
    }

    if (data.data?.sessionStartTimestamp) {
      params.ftOtpSessionStartTimestamp = data.data.sessionStartTimestamp
    }

    if (data.data?.sessionDurationMinutes) {
      params.ftOtpSessionDurationMinutes = data.data.sessionDurationMinutes
    }

    dispatch(
      setTargetParamsValue({
        params,
      })
    )

    if (data.accessToken && data.accessSalt) {
      ftSetLocalStorage(SESSION_TOKEN_NAME, data.accessToken)
      ftSetLocalStorage(SESSION_SALT_NAME, data.accessSalt)
    }

    ftSetLocalStorage(OTP_SESSION_IS_ACTIVE, true)

    let retState = getAppState()
    let processList = List()
    let validVerify = retState.getIn(['__otp_cache__', 'validVerify'], List())
    if (validVerify.size) {
      processList = processList.concat(validVerify)
    }
    if (hashJobs && hashJobs.validVerify && _.size(hashJobs.validVerify)) {
      processList = processList.concat(fromJS(hashJobs.validVerify))
    }
    if (processList.size) {
      retState = retState.setIn(['__cache__'], retState.getIn(['__cache__'], List()).concat(processList))
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: retState,
        },
      })
    }

    /**
     * Recreate SF Platform Events socket connection with OTP session cookies
     */
    if (typeof window?.__FT_PROJECT__API__?.reconnectSocket === 'function') {
      window.__FT_PROJECT__API__.reconnectSocket()
    }
  } else {
    processErrors()
  }

  if (callback) {
    callback(data)
  }
}
